import MaterialAutoComplete from '@material-ui/lab/Autocomplete'
import MaterialTextField from '@material-ui/core/TextField'
import MaterialPopper from '@material-ui/core/Popper'
import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import border from '../../tokens/border'
import layout from '../../tokens/layout'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const MuAutoComplete = styled(MaterialAutoComplete).attrs((props) =>
  composeTheme(props),
)`
  width: 100%;

  .MuiAutocomplete-popupIndicator {
    margin-right: 0.4rem;
    color: ${(props) => props.theme.autoComplete.color};
  }

  .gneEvU.size-small {
    margin: 0.6rem;
  }

  .MuiOutlinedInput-root {
    padding: 0 !important;

    .theme-active {
      margin: 0.25rem 0.3125rem 0rem;
      max-width: calc(100% - 5rem);

      span {
        overflow: hidden;
        padding-bottom: 0.3125rem;
        padding-top: 0.25rem;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`
MuAutoComplete.defaultProps = defaultTheme

export const Popper = styled(MaterialPopper).attrs((props) =>
  composeTheme(props),
)`
  &:hover {
    background-color: transparent;
  }

  .MuiAutocomplete-listbox {
    .MuiAutocomplete-option {
      color: ${(props) => props.theme.autoComplete.optionColor};
      font-family: ${fonts.inter};
      font-size: ${(props) => props.theme.autoComplete.optionFontSize};

      &[data-focus='true'] {
        background-color: ${colors.neutralColorHighMedium};
      }
    }

    &:hover {
      background-color: transparent;
      color: ${(props) => props.theme.brandColors.primaryPure};
      font-weight: 400;
    }
    padding: 0px;
  }
`
Popper.defaultProps = defaultTheme

export const TextField = styled(MaterialTextField).attrs((props) =>
  composeTheme(props),
)`
  &.is-negative {
    .MuiInputBase-root {
      background-color: ${colors.feedbackColorNegativeLight};

      .MuiInputBase-input {
        color: ${colors.feedbackColorNegativePure};
      }

      .MuiOutlinedInput-notchedOutline {
        border: 0.2rem solid ${colors.feedbackColorNegativePure};
      }
    }
  }

  .MuiInputBase-root {
    color: ${(props) => props.theme.autoComplete.color};
    font-family: ${fonts.inter};
    font-size: ${(props) => props.theme.autoComplete.fontSize};
    line-height: ${(props) => props.theme.autoComplete.fontHeight};
    padding: 0;
    outline-color: ${(props) => props.theme.brandColors.primaryPure};
    background-color: ${(props) => props.theme.autoComplete.background};
    min-height: 4rem;
    height: 100%;
    max-height: 8rem;
    overflow-y: auto;
    position: initial;

    ::-webkit-scrollbar {
      width: 0.3rem;
    }

    ::-webkit-scrollbar-track {
      margin-block: ${layout.margin.spacingQuarck};
    }

    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.autoComplete.background};
      border-radius: ${border.radius.radiusSm};
    }

    .MuiOutlinedInput-notchedOutline {
      border-radius: ${border.radius.radiusSm};
      border: ${(props) => props.theme.autoComplete.borderWidth} solid
        ${(props) => props.theme.autoComplete.borderColor};
      margin-right: -${layout.margin.spacingQuarck};
    }

    .MuiAutocomplete-endAdornment {
      align-self: flex-start;
      top: auto;
    }

    .MuiAutocomplete-input {
      padding: ${(props) => props.theme.autoComplete.paddingTop}
        ${(props) => props.theme.autoComplete.paddingRight}
        ${(props) => props.theme.autoComplete.paddingBotton}
        ${(props) => props.theme.autoComplete.paddingLeft} !important;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) => props.theme.brandColors.primaryPure};
    }

    &.Mui-disabled {
      background-color: ${(props) =>
        props.theme.autoComplete.disabledBackground};
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
          props.theme.autoComplete.disabledBorderColor};
      }
    }

    .MuiInputBase-input {
      color: ${(props) => props.theme.autoComplete.color};
      height: auto;

      &::placeholder {
        color: ${(props) =>
          props.theme.autoComplete.placeholderColor} !important;
      }

      ::-webkit-input-placeholder {
        color: ${(props) => props.theme.autoComplete.placeholderColor};
      }

      :-moz-placeholder {
        /* Firefox 18- */
        color: ${(props) => props.theme.autoComplete.placeholderColor};
      }

      ::-moz-placeholder {
        /* Firefox 19+ */
        color: ${(props) => props.theme.autoComplete.placeholderColor};
      }

      :-ms-input-placeholder {
        color: ${(props) => props.theme.autoComplete.placeholderColor};
      }

      &::placeholder {
        opacity: 1;
      }
    }

    .MuiIconButton-label {
      height: 2.4rem;
      width: 2.4rem;
    }
  }
`
TextField.defaultProps = defaultTheme

export const Hint = styled.p.attrs((props) => composeTheme(props))`
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: ${(props) => props.theme.hint.fontWeight};
  font-size: ${(props) => props.theme.hint.fontSize};
  align-items: left;
  color: ${(props) => props.theme.hint.color};
  margin-top: ${(props) => props.theme.hint.paddingTop};
  margin-bottom: ${(props) => props.theme.hint.marginBottom};

  &.is-negative {
    color: ${(props) => props.theme.hint.negativeColor};
  }
`
Hint.defaultProps = defaultTheme
